module.exports = __webpack_public_path__ + "static/media/sf-test-2.5cf94818.mp3";